import { STORAGE_KEYS } from '../config';
import {
  RECENT_ASSIGNEE_LIMIT,
  normalizeUser,
  rememberRecentUsers,
  uniqueUsers,
} from './userSearch.js';

const KEY = STORAGE_KEYS.RECENT_TASK_ASSIGNEES;

export function loadRecentAssignees() {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return uniqueUsers(Array.isArray(parsed) ? parsed : []).slice(
      0,
      RECENT_ASSIGNEE_LIMIT,
    );
  } catch {
    return [];
  }
}

export function saveRecentAssignees(users) {
  const next = uniqueUsers(users).slice(0, RECENT_ASSIGNEE_LIMIT);
  if (typeof localStorage === 'undefined') return next;
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Quota / private mode — recents are a convenience, never blocking.
  }
  return next;
}

export function rememberAssignees(incoming) {
  const rows = (incoming || []).map(normalizeUser).filter(Boolean);
  if (!rows.length) return loadRecentAssignees();
  return saveRecentAssignees(rememberRecentUsers(loadRecentAssignees(), rows));
}
